import React from "react";
import Banner from "./Banner";
import Cta from "./Cta";
import Footer from "./Footer";
import Navbar from "./Navbar";
import Service from "./Service";
import Toprated from "./Toprated";
import Tvseries from "./Tvseries";
import Upcoming from "./Upcoming";

function Home() {
  return (
    <>
      <Navbar />
      <Banner />
      <Upcoming />
      <Service />
      <Toprated />
      <Tvseries />
      <Cta />
      <Footer />
    </>
  );
}

export default Home;
